import {i18n} from "i18next";

import {IUserModel} from "./shared_types/user_model";

export const getLockerLabel = (i18n: i18n, userData: IUserModel | null, isLoggedIn?: boolean): string => {
    switch (true) {
        case !isLoggedIn:
            return i18n.t("common.chart_lock.access_paid");
        case userData && !userData.email_verified:
            return i18n.t("common.chart_lock.confirm_email");
        default:
            return i18n.t("common.chart_lock.access_paid_contact");
    }
};
